module.exports = __webpack_public_path__ + "img/white-top-left.42a7ab0e.png";